import {EntityData, field, identifier} from "@fedeltapointofsale/data-client";

export class FunctionBarData extends EntityData<FunctionBarData> {
    @identifier id: number;
    @field name: string;
}
